/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemMinimalListResponseWithoutCount } from '../../models/travel-item-minimal-list-response-without-count';

export interface TravelControllerGetFavouriteTravels$Params {
}

export function travelControllerGetFavouriteTravels(http: HttpClient, rootUrl: string, params?: TravelControllerGetFavouriteTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponseWithoutCount;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetFavouriteTravels.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemMinimalListResponseWithoutCount;
      }>;
    })
  );
}

travelControllerGetFavouriteTravels.PATH = '/travel/fav';
